export default {"src":"/_next/static/media/app-play-store.f5976de1.svg","height":40,"width":343,"blurWidth":0,"blurHeight":0};